import { useEffect } from "react";
import { FC, Props, ListItem } from "./typings";
import React from "react";
import styles from "./styles.module.scss";

const ListControl: FC<Props> = ({
  items,
  renderItem,
  selectedItems,
  setSelectedItems,
  getItemId,
  checklist = false,
}) => {
  const isSelected = (item: ListItem) =>
    selectedItems.some((x) => getItemId(x) === getItemId(item));

  const toggle = (item: ListItem) => {
    if (isSelected(item)) {
      setSelectedItems(
        selectedItems.filter((i) => getItemId(i) !== getItemId(item))
      );
    } else {
      setSelectedItems([...selectedItems, item]);
    }
  };

  // Handle clicking an item
  const handleItemClick = (
    item: any,
    event: React.MouseEvent<HTMLLIElement, MouseEvent>
  ) => {
    if (checklist) {
      // Tryb checklisty — klik wiersza przełącza zaznaczenie.
      toggle(item);
      return;
    }
    const isCtrlPressed = event.ctrlKey || event.metaKey; // MetaKey for macOS support

    if (isCtrlPressed) {
      // Toggle selection when Ctrl is pressed
      if (selectedItems.includes(item)) {
        setSelectedItems(
          selectedItems.filter((i) => getItemId(i) !== getItemId(item))
        ); // Remove item from selection
      } else {
        setSelectedItems([...selectedItems, item]); // Add item to selection
      }
    } else {
      // Select only the clicked item if Ctrl is not pressed
      setSelectedItems([item]);
    }
  };

  useEffect(() => {
    console.log("Selected items", selectedItems);
  }, [selectedItems]);

  return (
    <div className={styles.list}>
      <ul
        className={styles.noindent}
        ref={(node) => {
          if (node) {
            node.style.setProperty("paddingInlineStart", "0px", "important");
          }
        }}
      >
        {items &&
          items.map((item) => (
            <li
              key={"listItem" + getItemId(item)}
              onClick={(event) => handleItemClick(item, event)}
              className={styles.noindent}
              style={{
                cursor: "pointer",
                display: checklist ? "flex" : undefined,
                alignItems: checklist ? "center" : undefined,
                backgroundColor:
                  !checklist && isSelected(item) ? "#e6def3" : "transparent",
              }}
            >
              {checklist && (
                <input
                  type="checkbox"
                  checked={isSelected(item)}
                  onChange={() => toggle(item)}
                  onClick={(e) => e.stopPropagation()}
                  style={{ margin: "0 8px", cursor: "pointer", flexShrink: 0 }}
                />
              )}
              {renderItem(item)}
            </li>
          ))}
      </ul>
    </div>
  );
};

export default ListControl;
